import React from 'react';
import { Card } from '../components/UI/Card';
import { Button } from '../components/UI/Button';
import { Mail, Handshake } from 'lucide-react';
export const Partners = () => {
  const partners = [{
    name: 'Not A Flower Girl Ltd.',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/fzw81HLpEsCdXEuQ5n5hSj/2.png',
    description: 'Leading creative agency supporting cultural initiatives.'
  }, {
    name: 'Brooks & Brown',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/o3ypkjhB7kJ2Wy5Za65rMU/3.png',
    description: 'Consulting firm specializing in community development.'
  }, {
    name: 'Andre MORE Ideation',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/rAwr3ugU2e9fekWEX2roAw/4.png',
    description: 'Innovation hub for emerging entrepreneurs.'
  }, {
    name: 'The Work Haven',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/qnj3kw6MbAbRKB8AWygyGk/5.png',
    description: 'Co-working space and community for professionals.'
  }];
  return <div className="pt-20" data-id="element-4292" data-mp="vrnxoddox1hu">
      <section className="py-16 bg-secondary/5" data-id="element-4293" data-mp="vrxmvyqwv4mh">
        <div className="container mx-auto px-4" data-id="element-4294" data-mp="qs1lm79llram">
          <h1 className="text-4xl font-bold text-center text-secondary-dark mb-6" data-id="element-4295" data-mp="qr9up9qy4hqo">
            Our Partners
          </h1>
          <p className="text-center text-lg text-secondary max-w-3xl mx-auto" data-id="element-4296" data-mp="lv1cfnhgc8fa">
            We collaborate with forward-thinking organizations to create more
            opportunities, resources, and connections for our community members.
          </p>
        </div>
      </section>
      <section className="py-16" data-id="element-4297" data-mp="19j2q1athmf1k">
        <div className="container mx-auto px-4" data-id="element-4298" data-mp="14rt3wk75dtuf">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 mb-16" data-id="element-4299" data-mp="14qi0wmlj0q4d">
            {partners.map((partner, index) => <Card key={index} className="p-6 flex flex-col items-center" data-id="element-4300" data-mp="10ppqhq0x4f6i" data-mpi={index}>
                <div className="h-24 mb-6 flex items-center justify-center" data-id="element-4301" data-mp="1x8dnaibmpray">
                  <img src={partner.logo} alt={partner.name} className="max-h-full max-w-full object-contain" data-id="element-4302" data-mp="1shneev3zv6bi" />
                </div>
                <h3 className="text-xl font-bold text-secondary-dark mb-2 text-center" data-id="element-4303" data-mp="3mqk6y06m4qng">
                  {partner.name}
                </h3>
                <p className="text-secondary text-center mb-4" data-id="element-4304" data-mp="3rq6j06apg0uo">
                  {partner.description}
                </p>
              </Card>)}
          </div>
          <div className="bg-secondary/5 rounded-lg p-8 border border-gray-200" data-id="element-4305" data-mp="3hx7ueof7kab2">
            <div className="flex flex-col md:flex-row items-center gap-8" data-id="element-4306" data-mp="33yhw55gnk4l4">
              <div className="md:w-2/3" data-id="element-4307" data-mp="38xkuk724nck4">
                <h2 className="text-2xl font-bold text-secondary-dark mb-4" data-id="element-4308" data-mp="38ym4g87ept09">
                  Become a Partner
                </h2>
                <p className="text-secondary mb-6" data-id="element-4309" data-mp="2u2y4iv94fs26">
                  Partner with The Networking Salon to co-create events, share
                  resources, and connect with our global community of
                  professionals and changemakers. We're always looking for
                  organizations that align with our mission of building
                  meaningful connections and creating opportunities.
                </p>
                <div className="flex flex-wrap gap-4" data-id="element-4310" data-mp="2crrfnj2kqf8l">
                  <Button data-id="element-4311" data-mp="2cp6fcyhxc7cy">
                    <Mail className="mr-2" size={18} data-id="element-4312" data-mp="2rfvsw7iuxyjz" />
                    Contact Us
                  </Button>
                  <Button variant="outline" data-id="element-4313" data-mp="2moxbt5q1owfo">
                    <Handshake className="mr-2" size={18} data-id="element-4314" data-mp="2mo4bonlld56i" />
                    Partnership Guide
                  </Button>
                </div>
              </div>
              <div className="md:w-1/3 border-2 border-gray-300 rounded-lg p-4 bg-white" data-id="element-4315" data-mp="2we70scpldyzk">
                <h3 className="text-lg font-bold text-secondary-dark mb-2" data-id="element-4316" data-mp="3af9osv05djd4">
                  Partnership Benefits
                </h3>
                <ul className="space-y-2" data-id="element-4317" data-mp="35gge1ac8w6gn">
                  <li className="flex items-start" data-id="element-4318" data-mp="1g0ql4p3vd9ti">
                    <div className="w-1.5 h-1.5 rounded-full bg-primary mt-2 mr-2" data-id="element-4319" data-mp="1g1igbytk15j9"></div>
                    <span data-id="element-4320" data-mp="1b376ho39ev11">Access to our global network</span>
                  </li>
                  <li className="flex items-start" data-id="element-4321" data-mp="1ci1a22roaks6">
                    <div className="w-1.5 h-1.5 rounded-full bg-primary mt-2 mr-2" data-id="element-4322" data-mp="1clfah5gs0jwz"></div>
                    <span data-id="element-4323" data-mp="1hk8r36rd0r1d">Co-branded events and content</span>
                  </li>
                  <li className="flex items-start" data-id="element-4324" data-mp="1mi0i7yk6k94i">
                    <div className="w-1.5 h-1.5 rounded-full bg-primary mt-2 mr-2" data-id="element-4325" data-mp="1rgv9low7r608"></div>
                    <span data-id="element-4326" data-mp="tstmf7c41xmy">Visibility with our community</span>
                  </li>
                  <li className="flex items-start" data-id="element-4327" data-mp="yro1pzavd42b">
                    <div className="w-1.5 h-1.5 rounded-full bg-primary mt-2 mr-2" data-id="element-4328" data-mp="ysg01hvupfwa"></div>
                    <span data-id="element-4329" data-mp="13ppuxd20ejri">Resource sharing opportunities</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>;
};